module.exports = __webpack_public_path__ + "assets/img/dayu_online_doctor.16603d44.png";